module.exports = __webpack_public_path__ + "img/Feature.7f484284.jpg";